import { createAction, createAsyncAction } from "typesafe-actions";
import { BaseResponse, WithCallback } from "@shared/interfaces";
import { User } from "@shared/models";

import { AuthActionTypes } from "./constants";
import {
  RestoreShape,
  ChangePasswordPayloadShape,
  ActivatePayloadShape,
  RegistrationPayloadShape,
  CheckUserShape,
  LoginPayloadShape,
  AuthErrorType,
  ImpersonationPayloadShape,
  LogoutRequestPayload,
} from "../interface";

export const login = createAsyncAction(
  AuthActionTypes.LOGIN,
  AuthActionTypes.LOGIN_SUCCESS,
  AuthActionTypes.LOGIN_FAILURE,
)<LoginPayloadShape, undefined, Error>();

export const checkUser = createAsyncAction(
  AuthActionTypes.CHECK_USER,
  AuthActionTypes.CHECK_USER_SUCCESS,
  AuthActionTypes.CHECK_USER_FAILURE,
)<CheckUserShape & { noRedirect?: boolean }, { filledEmail: string; isUserExist: boolean }, Error>();

export const logout = createAsyncAction(
  AuthActionTypes.LOGOUT,
  AuthActionTypes.LOGOUT_SUCCESS,
  AuthActionTypes.LOGOUT_FAILURE,
)<LogoutRequestPayload, undefined, Error>();

export const forgotPassword = createAsyncAction(
  AuthActionTypes.FORGOT_PASSWORD,
  AuthActionTypes.FORGOT_PASSWORD_SUCCESS,
  AuthActionTypes.FORGOT_PASSWORD_FAILURE,
)<RestoreShape, BaseResponse, Error>();

export const setPassword = createAsyncAction(
  AuthActionTypes.SET_PASSWORD,
  AuthActionTypes.SET_PASSWORD_SUCCESS,
  AuthActionTypes.SET_PASSWORD_FAILURE,
)<ChangePasswordPayloadShape, undefined, Error>();

export const resetPassword = createAsyncAction(
  AuthActionTypes.RESET_PASSWORD,
  AuthActionTypes.RESET_PASSWORD_SUCCESS,
  AuthActionTypes.RESET_PASSWORD_FAILURE,
)<ChangePasswordPayloadShape, undefined, Error>();

export const registration = createAsyncAction(
  AuthActionTypes.REGISTRATION,
  AuthActionTypes.REGISTRATION_SUCCESS,
  AuthActionTypes.REGISTRATION_FAILURE,
)<WithCallback<RegistrationPayloadShape>, { token: string }, Error>();

export const activateAccount = createAsyncAction(
  AuthActionTypes.ACTIVATE_ACCOUNT,
  AuthActionTypes.ACTIVATE_ACCOUNT_SUCCESS,
  AuthActionTypes.ACTIVATE_ACCOUNT_FAILURE,
)<ActivatePayloadShape, Partial<User> | null, Error>();

export const impersonation = createAsyncAction(
  AuthActionTypes.IMPERSONATE,
  AuthActionTypes.IMPERSONATE_SUCCESS,
  AuthActionTypes.IMPERSONATE_FAILURE,
)<ImpersonationPayloadShape, undefined, Error>();

export const impersonationExit = createAsyncAction(
  AuthActionTypes.IMPERSONATION_EXIT,
  AuthActionTypes.IMPERSONATION_EXIT_SUCCESS,
  AuthActionTypes.IMPERSONATION_EXIT_FAILURE,
)<void, void, Error>();

export const setRedirectTo = createAction(AuthActionTypes.SET_REDIRECT_TO)<string | null>();

export const clearError = createAction(AuthActionTypes.CLEAR_ERROR)<AuthErrorType>();

export const clearUserExistence = createAction(AuthActionTypes.CLEAR_USER_EXISTENCE)();
export const clearFilledEmail = createAction(AuthActionTypes.CLEAR_FILLED_EMAIL)();
